
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {}
})
export default class extends Vue {
  public selectReasonList = [
    {
      lang: 'zh',
      data: [
        {
          id: 1,
          title: '全球版面 · 安心无忧',
          desc1: 'Prestige 在全球主要留学目的地',
          desc2: '均设有学生公寓，',
          desc3: '统一品牌管理，确保你无论身处何地，',
          desc4: '都能享受到同样的高标准服务。 '
        },
        {
          id: 2,
          title: '黄金地段 · 出行便利',
          desc1: '公寓选址优越，靠近市中心或学校，',
          desc2: '步行即可到达地铁、巴士站与生活设施，',
          desc3: '让学习与生活更有效率。 ',
          desc4: ''
        },
        {
        id: 3,
          title: '拎包入住 · 设施齐全',
          desc1: '房间配备全套家具与家电，公共设施完善，',
          desc2: 'WiFi、洗衣机、厨房一应俱全，',
          desc3: '让你轻松入住，无后顾之忧。 ',
          desc4: ''
        },
        {
          id: 4,
          title: '专业管理 · 安全保障',
          desc1: '24小时保全与智慧门禁系统，',
          desc2: '专业管理团队随时待命，确保居住安全，',
          desc3: '并为你的日常需求提供协助。 ',
          desc4: ''
        },
        {
          id: 5,
          title: '友善社区 · 融洽氛围',
          desc1: '留学生打造友善多元的国际社区，',
          desc2: '既能互相支持，也能拓展跨文化人脉。 ',
          desc3: '',
          desc4: ''
        },
        {
          id: 6,
          title: '温暖关怀 · 活动丰富',
          desc1: 'Prestige 不只是住宿，',
          desc2: '更是你在海外的「第二个家」。 ',
          desc3: '我们定期举办节庆庆祝与社交活动，',
          desc4: '让你在异国他乡也能感受到归属感。 '
        }
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
          id: 1,
          title: '全球版面 · 安心無憂',
          desc1: 'Prestige 在全球主要留學目的地',
          desc2: '均設有學生公寓，',
          desc3: '統一品牌管理，確保你無論身處何地，',
          desc4: '都能享受到同樣的高標準服務。'
        },
        {
          id: 2,
          title: '黃金地段 · 出行便利',
          desc1: '公寓選址優越，靠近市中心或學校，',
          desc2: '步行即可到達地鐵、巴士站與生活設施，',
          desc3: '讓學習與生活更有效率。',
          desc4: ''
        },
        {
          id: 3,
          title: '拎包入住 · 設施齊全',
          desc1: '房間配備全套家具與家電，公共設施完善，',
          desc2: 'WiFi、洗衣機、廚房一應俱全，',
          desc3: '讓你輕鬆入住，無後顧之憂。',
          desc4: ''
        },
        {
          id: 4,
          title: '專業管理 · 安全保障',
          desc1: '24小時保全與智慧門禁系統，',
          desc2: '專業管理團隊隨時待命，確保居住安全，',
          desc3: '並為你的日常需求提供協助。',
          desc4: ''
      },
      {
          id: 5,
          title: '友善社區 · 融洽氛圍',
          desc1: '留學生打造友善多元的國際社區，',
          desc2: '既能互相支持，也能拓展跨文化人脈。',
          desc3: '',
          desc4: ''
      },
      {
          id: 6,
          title: '溫暖關懷 · 活動豐富',
          desc1: 'Prestige 不只是住宿，',
          desc2: '更是你在海外的「第二個家」。',
          desc3: '我們定期舉辦節慶慶祝與社交活動，',
          desc4: '讓你在異國他鄉也能感受到歸屬感。'
      }
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
          id: 1,
          title: 'Global Prestige · Peace of Mind',
          desc1: 'Prestige offers student housing in major study abroad destinations worldwide',
          desc2: 'Student housing is available in all major study abroad destinations worldwide',
          desc3: 'Unified brand management ensures you receive the same high-standard service wherever you are',
          desc4: 'You can enjoy the same high-standard service.'
        },
        {
          id: 2,
          title: 'Prime Location · Convenient Transportation',
          desc1: 'Apartments are strategically located near the city center or schools',
          desc2: 'Within walking distance of subways, bus stops, and daily amenities',
          desc3: 'Making your study and living more efficient. ',
          desc4: ''
        },
        {
          id: 3,
          title: 'Move-in ready · Complete facilities',
          desc1: 'Rooms are fully furnished and equipped with appliances, and public facilities are complete.',
          desc2: 'WiFi, washing machine, and kitchen are all available.',
          desc3: 'Enjoy a worry-free move-in.',
          desc4: ''
        },
        {
          id: 4,
          title: 'Professional management · Security',
          desc1: '24-hour security and smart access control system.',
          desc2: 'A professional management team is on call at all times to ensure your safety.',
          desc3: 'We will also provide assistance with your daily needs. ',
          desc4: ''
        },
        {
          id: 5,
          title: 'Friendly Community · Harmonious Atmosphere',
          desc1: 'International students create a friendly and diverse international community,',
          desc2: 'You can support each other and expand cross-cultural connections.',
          desc3: '',
          desc4: ''
        },
        {
          id: 6,
          title: 'Warm and Caring · Rich Activities',
          desc1: 'Prestige is more than just accommodation,',
          desc2: 'It\'s your "second home" abroad.',
          desc3: 'We regularly host festivals and social events,',
          desc4: 'Your sense of belonging even in a foreign country.'
        }
      ]
    },
  ];
  public getSelectReasonList() {
    return this.selectReasonList.find((item: any)=>item.lang === AppModule.language)?.data;
  }
}
